import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ThreatsBars } from '../../../components/operator-dashboard/threats-box/ThreatsBars';
import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './Threats.scss';
type Props = {
  darkMode: any;
};


export const ThreatsByType = (props:Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { operatorId, cpeId } = useParams();

  const [accountsData, setAccountsData] = useState<any>();

  const [selectedRange, setSelectedRange] = useState<number>(1);

  const handleDateRangeChange = (days: number) => {
    setSelectedRange(days);
  };

  const handleSelectedRangeChange = (selectedRange: number) => {
    // Handle the selectedRange value in the parent component
    fetchApi(selectedRange);
  };
  async function fetchApi(selectedRange: number | undefined = 1) {
    try {
      // const threatsMitigated = await axios.get(`v2/op/router/${handleId}/device-threats?days=${selectedRange}`);
      const threatsMitigated = await axios.get(`v2/op/router/${cpeId}/device-threats?days=${selectedRange}`);
      console.log(`v2/op/router/${cpeId}/device-threats?days=${selectedRange}`)

      console.log(props.darkMode ,"props.darkModeprops.darkModeprops.darkModeprops.darkMode");
      setAccountsData(threatsMitigated?.data);
    } catch (error) {
      // Handle any errors that occur during the API calls
      console.error('Error fetching API data:', error);
    }
  } 

  return (
    // Reuses the themed `.dd-threats` layout (device-details/threats/Threats.scss) for ThreatsBars
    <section className="dd-threats">
      <header className="dd-threats-hd">
        <span className="dd-threats-icon" aria-hidden="true">
          <ShieldAlert size={16} strokeWidth={1.75} />
        </span>
        <div className="dd-threats-hd-text">
          <h2 className="bd-h2">{t('cpeTabs.threats.title')}</h2>
          <span className="bd-meta">{t('cpeTabs.threats.description')}</span>
        </div>
      </header>
      <div className="dd-threats-body">
        <ThreatsBars darkmode={props.darkMode} accountsData={accountsData} onSelectedRangeChange={handleSelectedRangeChange} />
      </div>
    </section>
  );
};
